export function formatFileSize(bytes) {
  if (bytes === 0) return '0 Bytes';
  if (bytes < 0 || isNaN(bytes)) return ''; // Invalid Size

  const units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
  const i = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    units.length - 1
  );

  const size = bytes / Math.pow(1024, i);
  return `${size.toFixed(2)} ${units[i]}`;
}
